module.exports = __webpack_public_path__ + "img/draft-writing.0bb8b137.png";